module.exports = __webpack_public_path__ + "static/media/login.9aca8541.jpg";